<template>
    <div class="repeat-info" v-if="has_only_values">
        <div v-for="(val, key) in only_values">
            <strong>{{key}}:</strong> {{ val }}
        </div>
    </div>
</template>

<script>
import {titleize} from "@/utils";

export default {
    name: "RepeatInfo",
    props: ['values', 'only'],

    computed: {
        only_values(){
            if( !this.only || this.only.length === 0 ) return this.values;

            let only = [];
            let values = {};

            if( typeof this.only === 'string' ){
                only = this.only.split(',');
            }

            for( const i in only ){
                if( typeof this.values[ only[i] ] !== 'undefined' ){
                    values[ titleize( only[i] ) ] = this.values[ only[i] ];
                }
            }

            return values;

        },

        has_only_values(){
            return Object.keys( this.only_values ).length > 0;
        }

    }

}
</script>

<style scoped>

</style>
